module.exports = __webpack_public_path__ + "assets/img/f63be8341080dd90b5c1bc91ddea23f5.png";